<template>
	<div class="header">
		<div v-if="!user">
			<input placeholder="username" v-model="username" />
			<input placeholder="password" v-model="password" />
			<button @click="login">Login</button>
		</div>
		<div v-else class="info_tag">
			<router-link
				v-for="route in [
					'uploader',
					'list',
					'users',
					'feedbacks',
					'dictionary',
				]"
				:key="route"
				:to="{ name: route }"
				class="menu_link"
				:class="{ active_link: $route.name === route }"
			>
				{{ route }}
			</router-link>

			<div style="padding: 8px">–</div>
			logged in as
			<p style="font-weight:bold; margin-left: 6px">
				{{ user.email.replace("@alduin.com", "") }}
			</p>
		</div>
	</div>
</template>

<script>
export default {
	props: ["is_song", "clear"],
	data() {
		return {
			username: "",
			password: "",
		};
	},
	mounted() {},
	computed: {
		user() {
			return this.$auth.currentUser;
		},
	},
	methods: {
		login() {
			const { username, password } = this;
			this.$auth.signInWithEmailAndPassword(username + "@alduin.com", password);
		},
	},
};
</script>

<style scoped>
.header {
	width: 100%;
}
.info_tag {
	height: 40px;
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding: 0 20px;
}
.menu_link {
	color: black;
	border-bottom: 1px solid black;
	padding: 0 4px 0 8px;
	padding-bottom: 0.33px;
	letter-spacing: 5px;
	cursor: pointer;
	margin: 0 6px;
	text-decoration: none;
}
.active_link {
	color: red;
	border-color: red;
}
</style>
